import { ArrowLeft } from "@mui/icons-material";
import { Box, styled, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";

const Caption = styled("p")({
  fontSize: "12px",
  color: COLORS.GRAY,
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
const DomesticMarketProductPriceChartFavoriteProducerCard = ({ favorite }) => {
  const { company, group, commodity } = favorite;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
        {company}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        <Caption>
          {group}
          {commodity && <ArrowLeft />}
        </Caption>

        <Caption>{commodity}</Caption>
      </Box>
    </Box>
  );
};

export default DomesticMarketProductPriceChartFavoriteProducerCard;
